import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchBlogs } from '../../store/slices/blogSlice';

const HomeBlogs = () => {
  const dispatch = useDispatch();
  const { items: blogs, loading } = useSelector((state) => state.blog);

  useEffect(() => {
    dispatch(fetchBlogs({ page: 1, limit: 3 }));
  }, [dispatch]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="font-heading text-5xl md:text-6xl font-black text-black mb-6 uppercase tracking-tight">
              Latest Blog Posts
            </h2>
            <div className="w-24 h-1 bg-primary mx-auto mt-4"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <div key={i} className="bg-white rounded-lg shadow p-4 animate-pulse">
                <div className="w-full h-48 bg-gray-200 rounded mb-4" />
                <div className="h-4 bg-gray-200 rounded mb-2" />
                <div className="h-4 bg-gray-200 rounded w-2/3" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  if (!blogs || blogs.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="font-heading text-5xl md:text-6xl font-black text-black mb-6 uppercase tracking-tight">
            Latest Blog Posts
          </h2>
          <p className="text-gray-700 text-xl font-semibold mb-4">
            Insights on Art, Vastu & Home Decor
          </p>
          <div className="w-24 h-1 bg-primary mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {blogs.map((blog) => (
            <Link
              key={blog._id}
              to={`/blog/${blog._id}`}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2 group"
            >
              {blog.image && (
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={blog.image}
                    alt={blog.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
              )}
              <div className="p-6">
                <span className="inline-block px-3 py-1 bg-secondary-light text-primary rounded-full text-xs mb-3 font-semibold">
                  {blog.category}
                </span>
                <h3 className="font-heading text-xl font-bold mb-3 line-clamp-2 group-hover:text-primary transition text-black">
                  {blog.title}
                </h3>
                {blog.excerpt && (
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3 leading-relaxed">
                    {blog.excerpt}
                  </p>
                )}
                <div className="flex items-center justify-between text-xs text-gray-500 pt-4 border-t">
                  <span className="font-semibold">{blog.author || 'Admin'}</span>
                  <span>{formatDate(blog.publishedAt || blog.createdAt)}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/blog"
            className="bg-primary text-white px-12 py-4 rounded-lg hover:bg-primary-dark transition-all transform hover:scale-105 shadow-xl font-bold text-lg uppercase tracking-wider inline-block"
          >
            Read All Blog Posts
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HomeBlogs;

